import { createApp } from 'vue';
import App from './App.vue';
import './assets/css/main.css';

const app = createApp(App);
app.mount('#app');